module.exports = __webpack_public_path__ + "img/aq.aq0aff28f.svg";